<template>
    <div class="site-logo">
        <router-link to="/" style="width: 100%;">
            <img :src="appLogo" alt="site logo" width="160" height="86">
        </router-link>
    </div>
</template>

<script>
import AppConfig from '@/constants/AppConfig'
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters(['sidebarSelectedFilter'])
    },
    data () {
        return {
            appLogo: AppConfig.appLogo
        }
    }
}
</script>
